module.exports = __webpack_public_path__ + "static/img/bot-thrusters-fg-optimized.9178d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bot-thrusters-fg-optimized.png
// module id = 484
// module chunks = 1